import { LegalShell } from "./LegalShell";

export function Terms() {
  return (
    <LegalShell title="Conditions Générales d'Utilisation">
      <p>Dernière mise à jour : <strong>9 mai 2026</strong></p>

      <h2>1. Objet</h2>
      <p>
        Les présentes CGU régissent l'utilisation de la plateforme Super-Pari, accessible via web et
        application mobile, proposant des pronostics sportifs avec abonnement, portefeuille et cagnotte hebdomadaire.
      </p>

      <h2>2. Accès au service</h2>
      <p>L'accès est strictement réservé aux personnes majeures (18 ans révolus). Toute fausse déclaration entraîne la résiliation immédiate du compte.</p>

      <h2>3. Compte utilisateur</h2>
      <ul>
        <li>Un seul compte par numéro de téléphone.</li>
        <li>L'utilisateur est responsable de la sécurité de son accès.</li>
        <li>Toute tentative de fraude (multi-comptes, usurpation, etc.) entraîne la suspension.</li>
      </ul>

      <h2>4. Abonnements et coupons</h2>
      <ul>
        <li>Les abonnements sont valables 1 mois calendaire à partir de leur souscription.</li>
        <li>Un seul coupon par type et par jour est autorisé.</li>
        <li>Un coupon est considéré gagnant uniquement si 100% des pronostics sont corrects.</li>
      </ul>

      <h2>5. Paiements</h2>
      <p>Les paiements (dépôts et retraits) transitent par PayDunya et les opérateurs mobile money (Wave, Orange Money, Free Money, Expresso). Super-Pari ne stocke aucune donnée bancaire.</p>

      <h2>6. Retraits</h2>
      <ul>
        <li>Les retraits sont validés manuellement par notre équipe sous 24h ouvrées.</li>
        <li>Le montant demandé est réservé sur le wallet jusqu'à validation ou rejet.</li>
        <li>Un retrait rejeté est intégralement remboursé sur le wallet.</li>
      </ul>

      <h2>7. Match annulé ou reporté</h2>
      <p>Si un match d'un coupon est annulé, reporté ou définitivement interrompu, le coupon entier est remboursé sur le wallet de l'utilisateur.</p>

      <h2>8. Plan Big Boss</h2>
      <p>Le plan Big Boss permet une mise libre à partir de 10 000 FCFA. En l'absence totale de gains au bout de 12 mois, la mise est remboursable sur demande à l'équipe support.</p>

      <h2>9. Parrainage</h2>
      <p>Les bonus de parrainage sont crédités uniquement après le premier paiement validé du filleul. Les tentatives de fraude (multi-comptes, IP partagées) peuvent entraîner l'annulation des bonus.</p>

      <h2>10. Limites de responsabilité</h2>
      <p>Super-Pari ne saurait être tenu responsable des pertes liées aux pronostics. Les utilisateurs sont invités à jouer de manière responsable.</p>

      <h2>11. Données personnelles</h2>
      <p>Voir la <a href="/legal/privacy">Politique de confidentialité</a>.</p>

      <h2>12. Modifications</h2>
      <p>Les CGU peuvent être modifiées à tout moment. Les utilisateurs sont notifiés des changements substantiels.</p>

      <h2>13. Loi applicable</h2>
      <p>Les présentes CGU sont régies par le droit sénégalais. En cas de litige, les tribunaux de Dakar sont seuls compétents.</p>
    </LegalShell>
  );
}
